var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_144_57)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.6667 15.9999C22.6667 16.7072 22.9476 17.3854 23.4477 17.8855C23.9478 18.3856 24.6261 18.6666 25.3333 18.6666C26.0406 18.6666 26.7189 18.3856 27.219 17.8855C27.7191 17.3854 28 16.7072 28 15.9999C27.9999 13.2513 27.0562 10.5861 25.3267 8.44985C23.5973 6.31359 21.1869 4.83578 18.4985 4.2635C15.8102 3.69121 13.0069 4.05915 10.5573 5.30579C8.10769 6.55244 6.16029 8.60222 5.04069 11.1124C3.92109 13.6226 3.69714 16.4411 4.4063 19.0966C5.11545 21.7521 6.71473 24.0837 8.93673 25.7015C11.1587 27.3194 13.8688 28.1254 16.6137 27.9848C19.3587 27.8442 21.9722 26.7656 24.0173 24.9292",
    stroke: "#FF7D61",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.33333 16.0002C9.33333 17.7683 10.0357 19.464 11.2859 20.7142C12.5362 21.9644 14.2319 22.6668 16 22.6668C17.7681 22.6668 19.4638 21.9644 20.714 20.7142C21.9643 19.464 22.6667 17.7683 22.6667 16.0002C22.6667 14.2321 21.9643 12.5364 20.714 11.2861C19.4638 10.0359 17.7681 9.3335 16 9.3335C14.2319 9.3335 12.5362 10.0359 11.2859 11.2861C10.0357 12.5364 9.33333 14.2321 9.33333 16.0002Z",
    stroke: "#FF7D61",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.6667 15.9998C14.6667 16.3535 14.8071 16.6926 15.0572 16.9426C15.3072 17.1927 15.6464 17.3332 16 17.3332C16.3536 17.3332 16.6928 17.1927 16.9428 16.9426C17.1929 16.6926 17.3333 16.3535 17.3333 15.9998C17.3333 15.6462 17.1929 15.3071 16.9428 15.057C16.6928 14.807 16.3536 14.6665 16 14.6665C15.6464 14.6665 15.3072 14.807 15.0572 15.057C14.8071 15.3071 14.6667 15.6462 14.6667 15.9998Z",
    stroke: "#FF7D61",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M14.6667 15.9998C14.6667 16.3535 14.8071 16.6926 15.0572 16.9426C15.3072 17.1927 15.6464 17.3332 16 17.3332C16.3536 17.3332 16.6928 17.1927 16.9428 16.9426C17.1929 16.6926 17.3333 16.3535 17.3333 15.9998C17.3333 15.6462 17.1929 15.3071 16.9428 15.057C16.6928 14.807 16.3536 14.6665 16 14.6665C15.6464 14.6665 15.3072 14.807 15.0572 15.057C14.8071 15.3071 14.6667 15.6462 14.6667 15.9998Z",
    stroke: "#FF7D61",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_144_57"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSvg);
export default __webpack_public_path__ + "static/media/email_svg.5846d0e13280b9676b90ab1d750860a8.svg";
export { ForwardRef as ReactComponent };